import Pagination from "@/components/pagination"
import { logStore } from "@/routes/admin/log/admin-log-store"
import { LOG_COLUMNS } from "@/routes/admin/log/admin-log-const"
import { useEffect } from "react"
import SearchBar from "@/routes/admin/_components/search-bar"
import { useState } from "react"
import TableHeader from "../_components/table/table-header"
import TableData from "../_components/table/table-data"

const AdminLogPage = () => {
  const { list, pagination, updateQuery } = logStore()

  useEffect(() => {
    logStore.getState().apiAction()
  }, [])

  const [keyword, setKeyword] = useState("")
  const rowGridClass = "grid grid-cols-[2fr_1fr_1fr_1fr_3fr_1fr]"

  const onSearch = async () => {
    await updateQuery({ keyword })
  }

  return (
    <section className="flex-1 flex flex-col">
      <article className="flex py-2">
        <SearchBar
          placeholder={"ID, 유저명으로 검색"}
          onChange={(e) => setKeyword(e.target.value)}
          value={keyword}
          onSubmit={onSearch}
        />
      </article>

      <TableHeader className={rowGridClass} columns={LOG_COLUMNS} />

      <TableData
        datalist={list}
        columns={LOG_COLUMNS}
        rowKey={"created_at"}
        className={rowGridClass}
      />

      <footer className="mt-auto">
        <Pagination
          currentPage={pagination.page}
          totalPages={Math.ceil(pagination.total / pagination.size)}
          onChange={(p) => updateQuery({ page: p })}
          activeStyle="bg-toicos-navy"
        />
      </footer>
    </section>
  )
}

export default AdminLogPage
